/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { ReverseZoneCreateExternal } from "../../models/reverse-zone-create-external";
import { ReverseZoneCreatePrimary } from "../../models/reverse-zone-create-primary";
import { ReverseZoneExternalRead } from "../../models/reverse-zone-external-read";
import { ReverseZonePrimaryRead } from "../../models/reverse-zone-primary-read";
import { Status } from "../../models/status";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface CreateReverseZone$Params {
  organisation_id: string;
  check?: boolean;
  body: ReverseZoneCreatePrimary | ReverseZoneCreateExternal;
}

export function createReverseZone(
  http: HttpClient,
  rootUrl: string,
  params: CreateReverseZone$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<(ReverseZonePrimaryRead | ReverseZoneExternalRead) | Status>> {
  const rb = new RequestBuilder(rootUrl, createReverseZone.PATH, "post");
  if (params) {
    rb.path("organisation_id", params.organisation_id, {});
    rb.query("check", params.check, {});
    rb.body(params.body, "application/json");
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<(ReverseZonePrimaryRead | ReverseZoneExternalRead) | Status>;
    }),
  );
}

createReverseZone.PATH = "/surfdomeinen/organisations/{organisation_id}/reverse/";
